import React, { useState, useEffect } from 'react';
import {Row,Col} from 'react-bootstrap';
import {getClaims} from './auth/sessionStore';
import {compose} from '../lib/compose';
import withAlerts from '../lib/withAlerts';
import {useRoleCheck} from '../lib/roleCheck';
import {useFeatureContext} from '../lib/context/featureContext';

const formatUTC = () =>
  new Intl.DateTimeFormat('en-US', {
    timeZone: 'UTC',
    month:    'short',
    day:      '2-digit',
    year:     'numeric',
    hour:     '2-digit',
    minute:   '2-digit',
    second:   '2-digit',
    hour12:   false,
  }).format(new Date());

const PageHeader = (props) => {
  const {feature_rbac} = useFeatureContext();
  const {preferred_username: username} = getClaims();
  const [titleUsername, setTitleUsername] = useState('');
  const [timestamp, setTimestamp] = useState(formatUTC);
  const {alerts} = props;
  const {info} = alerts;
  const hasRole = useRoleCheck(username);

  // Clock — ticks every second, same as the old interval={1000}
  useEffect(() => {
    const timer = setInterval(() => setTimestamp(formatUTC()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(()=>{
    if(username) {
      setTitleUsername(username);
    }
    
    //show the alert messages if RBAC is enabled
    if(feature_rbac) {
      //Checks to see if assigned role count >= 1
      if(!hasRole && hasRole !== undefined) {
        info({msg: "Contact administrator for PFC permissions."})
      }
    }
  }, [username, hasRole]);

  return (
    <div id="page-header" data-testid="page-header" className="p-3 sticky-top">
      <Row className="justify-content-end">
        <Col sm="auto" className="align-self-center">
          <span data-testid="timestamp">{timestamp}</span> UTC
        </Col>
        <Col sm="auto" className="align-self-center username ms-3">
          {titleUsername}
        </Col>
      </Row>  
    </div>
  );
};

export default compose(withAlerts)(PageHeader);
